import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import styles from './ResetPasswordForm.module.scss';
import LoginInput from 'component/atom/forms/login-components/input/LoginInput';
import LoginButton from 'component/atom/forms/login-components/button/LoginButton';

const mail = 'src/svg/vectors/mail.svg';
const backBtn = 'src/svg/vectors/backBtn.svg';
const aiDucatorLogo = 'src/svg/sidebar/logo.svg';

const ResetPasswordForm = ({ onSubmit, onBackToLogin }) => {
  const formik = useFormik({
    initialValues: { email: '' },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email').required('Email is required'),
    }),
    onSubmit: async (values, actions) => {
      actions.setStatus(null);

      try {
        if (onSubmit) {
          await onSubmit(values);
        } else {
          console.log('RESET PASSWORD:', values);
        }

        actions.setStatus('If this email exists, we sent a reset link.');
      } catch (err) {
        actions.setStatus(err?.message || 'Something went wrong. Try again.');
      } finally {
        actions.setSubmitting(false);
      }
    },
  });

  return (
    <div className={styles.card}>
      <div className={styles.logoRow}>
        <img src={aiDucatorLogo} alt='AiDucator' />
      </div>

      <button
        type='button'
        className={styles.backBtn}
        onClick={() =>
          onBackToLogin ? onBackToLogin() : console.log('Back to login')
        }
      >
        <img src={backBtn} alt='' className={styles.svg} /> Back to login
      </button>

      <div className={styles.welcomeMsg}>
        <h1 className={styles.title}>Reset Password</h1>
        <p className={styles.desc}>
          Enter your email address and we&apos;ll send you a link to reset your
          password
        </p>
      </div>

      {formik.status ? (
        <div
          className={
            formik.status?.toLowerCase().includes('sent')
              ? styles.formSuccess
              : styles.formError
          }
        >
          {formik.status}
        </div>
      ) : null}

      <form className={styles.form} onSubmit={formik.handleSubmit}>
        <LoginInput
          formik={formik}
          name='email'
          label='Email address'
          type='email'
          placeholder='Enter your email'
          autoComplete='email'
          svg={mail}
        />

        <LoginButton
          label='Send reset link'
          formik={formik}
          disabled={formik.isSubmitting || !formik.isValid}
        />

        {/* <p className={styles.footer}>
          By continuing, you agree to our <span>Terms of Service</span> and{' '}
          <span>Privacy Policy</span>.
        </p> */}
      </form>
    </div>
  );
};

export default ResetPasswordForm;
